import axios, { AxiosError } from "axios";
import { DAIKING_API } from "../../../config/globalVariables";
import { handleAxiosError } from "../../../utils/handleAxiosError";
import { jwtDecode } from "jwt-decode";

export const authClient = axios.create({
  baseURL: `${DAIKING_API.replace(/\/$/, "")}/api/auth/`,
});

// Request interceptor - Her istekte güncel token'ı ekle ve geçerliliğini kontrol et
authClient.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("jwtToken");
    if (token) {
      // Token süresini kontrol et
      try {
        const decoded = jwtDecode(token);
        const now = Math.floor(Date.now() / 1000); // Unix timestamp (seconds)

        if (decoded.exp && decoded.exp < now) {
          // Token süresi dolmuş
          localStorage.removeItem("jwtToken");
          localStorage.removeItem("aadToken");
          window.location.href = "/";
          return Promise.reject(new Error("Token expired"));
        }

        // Güncel token'ı header'a ekle
        config.headers.Authorization = `Bearer ${token}`;
      } catch (err) {
        console.error("Token decode error:", err);
      }
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  },
);

// Response interceptor - 401 Unauthorized durumunda logout yap
authClient.interceptors.response.use(
  (response) => response.data,
  (error) => {
    if (error instanceof AxiosError && error.isAxiosError && error.response) {
      // 401 Unauthorized - Token geçersiz veya yetki yok
      if (error.response.status === 401) {
        localStorage.removeItem("jwtToken");
        localStorage.removeItem("aadToken");
        window.location.href = "/";
        return Promise.reject(new Error("Unauthorized - redirecting to login"));
      }
      handleAxiosError(error);
    }
    throw error;
  },
);
